"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3798],{

/***/ 93798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Footer": function() { return /* binding */ Footer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var PopularSearches = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 2449).then(__webpack_require__.bind(__webpack_require__, 32449));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(32449)
            ];
        }
    },
    suspense: true
});
var PopularCities = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 6884).then(__webpack_require__.bind(__webpack_require__, 46884));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(46884)
            ];
        }
    },
    suspense: true
});
var ContactUs = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(260), __webpack_require__.e(9573)]).then(__webpack_require__.bind(__webpack_require__, 32721));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(32721)
            ];
        }
    },
    suspense: true
});
var UsefulLinks = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5445), __webpack_require__.e(3247)]).then(__webpack_require__.bind(__webpack_require__, 53539));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(53539)
            ];
        }
    },
    suspense: true
});
var Credit = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 257).then(__webpack_require__.bind(__webpack_require__, 90257));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(90257)
            ];
        }
    },
    suspense: true
});
var Footer = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("footer", {
        className: "bg-primary footer text-base",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "container mx-auto px-5 md:px-0",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Suspense, {
                fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col md:flex-row justify-center items-center md:justify-start md:items-start gap-10 py-5",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContactUs, {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PopularSearches, {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PopularCities, {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UsefulLinks, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Credit, {})
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Footer);


/***/ })

}]);